export const questions = [
    {
      questionText: "Mevalar tarkibidagi suvning miqdori o‘rtacha qanchani tashkil qiladi?",
      answerOptions: [
        { id: 1, answerText: "50-55% ni", isCorrect: false },
        { id: 2, answerText: "50-60% ni", isCorrect: false },
        { id: 3, answerText: "70-90% ni", isCorrect: true, },
        { id: 4, answerText: "25-50% ni", isCorrect: false },
      ],
    },
    {
      questionText: "Quruq vaznga nisbatan olmada pektin modda miqdorini necha foizni tashkil qiladi?",
      answerOptions: [
        { id: 1, answerText: "1,0-2,0% ni ", isCorrect: false },
        { id: 2, answerText: "2,0-3,0% ni", isCorrect: false },
        { id: 3, answerText: "0,25-1,80% ni", isCorrect: true, },
        { id: 4, answerText: "3,0-4,0% ni ", isCorrect: false },
      ],
    },
    {
      questionText: "Quruq vaznga nisbatan o‘rikda pektin modda miqdorini necha foizni tashkil qiladi?",
      answerOptions: [
        { id: 1, answerText: "1,5-2,0% ni", isCorrect: false },
        { id: 2, answerText: "0,05-1,50% ni", isCorrect: true },
        { id: 3, answerText: "2,0-2,5% ni", isCorrect: false, },
        { id: 4, answerText: "2,5-3,0% ni", isCorrect: false },
      ],
    },
    {
      questionText: "Quruq vaznga nisbatan bexida pektin modda miqdorini necha foizni tashkil qiladi?",
      answerOptions: [
        { id: 1, answerText: "2,5-3,0% ni", isCorrect: false },
        { id: 2, answerText: "2,0-2,5% ni", isCorrect: false },
        { id: 3, answerText: "1,5-2,0% ni", isCorrect: false, },
        { id: 4, answerText: "0,55-1,70% ni", isCorrect: true },
      ],
    },
    {
      questionText: "Quruq vaznga nisbatan nokda pektin modda miqdorini necha foizni tashkil qiladi?",
      answerOptions: [
        { id: 1, answerText: "1,5-2,0% ni", isCorrect: false },
        { id: 2, answerText: "0,50-1,50% ni", isCorrect: true },
        { id: 3, answerText: "2,0-2,5% ni", isCorrect: false, },
        { id: 4, answerText: "2,5-3,0% ni", isCorrect: false },
      ],
    },
    {
      questionText: "Quruq vaznga nisbatan shaftolida pektin modda miqdorini necha foizni tashkil qiladi?",
      answerOptions: [
        { id: 1, answerText: "2,0-2,5% ni", isCorrect: false },
        { id: 2, answerText: "1,5-2,0% ni", isCorrect: false },
        { id: 3, answerText: "0,04-1,29% ni", isCorrect: true, },
        { id: 4, answerText: "2,5-3,0% ni", isCorrect: false },
      ],
    },
    {
      questionText: "Quruq vaznga nisbatan olchada pektin modda miqdorini necha foizni tashkil qiladi?",
      answerOptions: [
        { id: 1, answerText: "0,4-0,9% ni", isCorrect: true },
        { id: 2, answerText: "1,5-2,0% ni", isCorrect: false },
        { id: 3, answerText: "2,0-2,5% ni", isCorrect: false, },
        { id: 4, answerText: "2,5-3,0% ni", isCorrect: false },
      ],
    },
    {
      questionText: "Quruq vaznga nisbatan olxo‘rida pektin modda miqdorini necha foizni tashkil qiladi?",
      answerOptions: [
        { id: 1, answerText: "1,5-2,0% ni", isCorrect: false },
        { id: 2, answerText: "0,30-1,60% ni", isCorrect: true },
        { id: 3, answerText: "2,0-2,5% ni", isCorrect: false, },
        { id: 4, answerText: "2,5-3,0% ni", isCorrect: false },
      ],
    },
    {
      questionText: "Quruq vaznga nisbatan uzumda pektin modda miqdorini necha foizni tashkil qiladi?",
      answerOptions: [
        { id: 1, answerText: "0,5-3,0% ni", isCorrect: false },
        { id: 2, answerText: "0,5-2,0% ni", isCorrect: false },
        { id: 3, answerText: " 0,1-2,5% ni", isCorrect: false, },
        { id: 4, answerText: "2,5-4,5% ni", isCorrect: true },
      ],
    },
    {
      questionText: "Umuman olganda mevalarning tarkibida qancha mineral modda bor?",
      answerOptions: [
        { id: 1, answerText: "50 dan ziyod", isCorrect: false },
        { id: 2, answerText: "60 dan ziyod", isCorrect: true },
        { id: 3, answerText: "40 dan ziyod", isCorrect: false, },
        { id: 4, answerText: "30 dan ziyod", isCorrect: false },
      ],
    },
    {
      questionText: "Qaysi usulda quritilgan maxsulot sifati juda yuqori bo‘ladi? ",
      answerOptions: [
        { id: 1, answerText: "sun’iy quritilgan mahsulot- majburiy oftobda quritilganiga nisbatan", isCorrect: false },
        { id: 2, answerText: "sun’iy quritilgan mahsulot- tabiiy oftobda quritilganiga nisbatan", isCorrect: false },
        { id: 3, answerText: "oftobda quritilgan mahsulot-sun’iy quritilganiga nisbatan ", isCorrect: false, },
        { id: 4, answerText: "oftobda quritilgan mahsulot-sun’iy quritilganiga nisbatan ", isCorrect: true },
      ],
    },
    {
      questionText: "Quritish maydonining har bir kvadrat metriga tilimlab kesilgan olmadan necha kg dan joylashtirish mumkin?",
      answerOptions: [
        { id: 1, answerText: "5-8 kg dan", isCorrect: true },
        { id: 2, answerText: "10-15 kg dan", isCorrect: false },
        { id: 3, answerText: "15-20 kg dan", isCorrect: false, },
        { id: 4, answerText: "20-25 kg dan", isCorrect: false },
      ],
    },
    {
      questionText: "Quritish maydonining har bir kvadrat metriga tilimlab kesilgan olxo‘ridan necha kg dan joylashtirish mumkin?",
      answerOptions: [
        { id: 1, answerText: "20-25 kg dan", isCorrect: false },
        { id: 2, answerText: "15-20 kg dan", isCorrect: false },
        { id: 3, answerText: "14-16 kg dan", isCorrect: true, },
        { id: 4, answerText: "10-15 kg dan", isCorrect: false },
      ],
    },
    {
      questionText: "Quritish maydonining har bir kvadrat metriga tilimlab kesilgan olcha va gilosdan necha kg dan joylashtirish mumkin?",
      answerOptions: [
        { id: 1, answerText: "10-15 kg dan", isCorrect: false },
        { id: 2, answerText: "8-10 kg dan ", isCorrect: true },
        { id: 3, answerText: "15-20 kg dan", isCorrect: false, },
        { id: 4, answerText: "20-25 kg dan", isCorrect: false },
      ],
    },
    {
      questionText: "Quritish maydonining har bir kvadrat metriga ikkiga bo‘lingan o‘rik yoki shaftolidan necha kg dan joylashtirish mumkin?",
      answerOptions: [
        { id: 1, answerText: "20-25 kg dan", isCorrect: false },
        { id: 2, answerText: "15-20 kg dan", isCorrect: false },
        { id: 3, answerText: "10-15 kg dan", isCorrect: false, },
        { id: 4, answerText: "10-12 kg dan ", isCorrect: true },
      ],
    },
    {
      questionText: "Quritish maydonining har bir kvadrat metriga uzumdan necha kg dan joylashtirish mumkin?",
      answerOptions: [
        { id: 1, answerText: "12-15 kg dan ", isCorrect: true },
        { id: 2, answerText: "10-15 kg dan", isCorrect: false },
        { id: 3, answerText: "15-20 kg dan", isCorrect: false, },
        { id: 4, answerText: "20-25 kg dan", isCorrect: false },
      ],
    },
    {
      questionText: "Mevalarning almashtirib bo‘lmaydigan tarkibiy qismi xisoblangan vitaminlardan qaysilari mavjud?",
      answerOptions: [
        { id: 1, answerText: "A1, D, V1, V2", isCorrect: false },
        { id: 2, answerText: "S, V1, V2, RR", isCorrect: true },
        { id: 3, answerText: "D2, A, RR, S", isCorrect: false, },
        { id: 4, answerText: "Ye3, RR, A, D", isCorrect: false },
      ],
    },
    {
      questionText: "Bir kilogramm mayizda qancha kaloriya bor?",
      answerOptions: [
        { id: 1, answerText: "2400-3250", isCorrect: true },
        { id: 2, answerText: "1500-2100", isCorrect: false },
        { id: 3, answerText: "1200-1500", isCorrect: false, },
        { id: 4, answerText: "1300-1400", isCorrect: false },
      ],
    },
    {
      questionText: "Mayiz tayyorlash uchun yig‘ishtiriladigan uzum qanddorligi konditsiya bo‘yicha kishmish navlari uchun necha foizdan kam bo‘lmasligi kerak?",
      answerOptions: [
        { id: 1, answerText: "11-20%  dan kam bo‘lmasligi lozim", isCorrect: false },
        { id: 2, answerText: "12-20%  dan kam bo‘lmasligi lozim", isCorrect: false },
        { id: 3, answerText: "23-25%  dan kam bo‘lmasligi lozim", isCorrect: true, },
        { id: 4, answerText: "10-15%  dan kam bo‘lmasligi lozim", isCorrect: false },
      ],
    },
    {
      questionText: "Mayiz tayyorlash uchun yig‘ishtiriladigan uzum qanddorligi konditsiya bo‘yicha urug‘li uzum navlari uchun necha foizdan kam bo‘lmasligi kerak?",
      answerOptions: [
        { id: 1, answerText: "11-20%  dan kam bo‘lmasligi lozim", isCorrect: false },
        { id: 2, answerText: "12-20%  dan kam bo‘lmasligi lozim", isCorrect: false },
        { id: 3, answerText: "10-15%  dan kam bo‘lmasligi lozim", isCorrect: false, },
        { id: 4, answerText: "22-23%  dan kam bo‘lmasligi lozim", isCorrect: true },
      ],
    },
    {
      questionText: "Shtabelgermiyon- qaysi uzum navlaridan va qanday quritiladi?",
      answerOptions: [
        { id: 1, answerText: "Hamma uzum navlaridan tabiiy va sun’iy usulda quritiladi", isCorrect: false },
        { id: 2, answerText: "Hamma uzum navlaridan soyada quritiladi", isCorrect: false },
        { id: 3, answerText: "Kattaqo‘rgon, Sultoni, Nimrang kabi navlardan oltingugurt bilan dudlab tayyorlanadi, keyin shtabellarga taxlab quritiladi.", isCorrect: true, },
        { id: 4, answerText: "Hamma uzum navlaridan oftobda quritiladi", isCorrect: false },
      ],
    },
    {
      questionText: "Qora vassarg‘a- qaysi uzum navlaridan va qanday quritiladi?",
      answerOptions: [
        { id: 1, answerText: "Qora uzum navlaridan dorilanmay oftobda quritiladi.", isCorrect: true },
        { id: 2, answerText: "Hamma uzum navlaridan oftobda quritiladi", isCorrect: false },
        { id: 3, answerText: "Hamma uzum navlaridan soyada quritiladi", isCorrect: false, },
        { id: 4, answerText: "Hamma uzum navlaridan tabiiy va sun’iy usulda quritiladi", isCorrect: false },
      ],
    },
    {
      questionText: "Chillaki- qaysi uzum navlaridan va qanday quritiladi?",
      answerOptions: [
        { id: 1, answerText: "Chillaki va Gerbosh uzum navlaridan dorilanmay oftobda quritiladi.", isCorrect: false },
        { id: 2, answerText: "Hamma uzum navlaridan oftobda quritiladi", isCorrect: true },
        { id: 3, answerText: "Hamma uzum navlaridan soyada quritiladi", isCorrect: false, },
        { id: 4, answerText: "Hamma uzum navlaridan tabiiy va sun’iy usulda quritiladi", isCorrect: false },
      ],
    },
    {
      questionText: "Sabza- quritish usuli bu...",
      answerOptions: [
        { id: 1, answerText: "qaynoq ishqor eritmasiga botirib olib, oftobda quritilgan mayiz.", isCorrect: true },
        { id: 2, answerText: "tabiiy qurilgan uzum", isCorrect: false },
        { id: 3, answerText: "sun’iy quritilgan uzum", isCorrect: false, },
        { id: 4, answerText: "soyaki mayiz", isCorrect: false },
      ],
    },
    {
      questionText: "Zarsimon sabza- quritish usuli bu...",
      answerOptions: [
        { id: 1, answerText: "avvalo ishqor eritmasiga botirib olib va oltingugurt angidridi bilan dudlab, so‘ngra shtabelda quritilgan oq kishmish.", isCorrect: false },
        { id: 2, answerText: "oltingugurt angidridi bilan dudlab quritish", isCorrect: false },
        { id: 3, answerText: "ishqor eritmasiga botirib olib quritish", isCorrect: false, },
        { id: 4, answerText: "oftobda quritish", isCorrect: true },
      ],
    },
    {
      questionText: "Soyaki- quritish usuli bu...",
      answerOptions: [
        { id: 1, answerText: "ishqor va oltingugurt qo‘llab quritiladi", isCorrect: false },
        { id: 2, answerText: "quritish qurilmasida quritiladi", isCorrect: false },
        { id: 3, answerText: "maxsus xonalarda oq kishmishdan soyaki qilib quritiladi ", isCorrect: true, },
        { id: 4, answerText: "sun’iy usulda hamma uzum navlarini quritadi", isCorrect: false },
      ],
    },
    {
      questionText: "Shig‘oniy-bu...",
      answerOptions: [
        { id: 1, answerText: "ishqor qo‘llab uzumni hamma navlaridan qilinadigan mayiz", isCorrect: false },
        { id: 2, answerText: "oq kishmishdan qilinadigan mayiz", isCorrect: false },
        { id: 3, answerText: "qora kishmishdan qilinadigan mayiz", isCorrect: true, },
        { id: 4, answerText: "Chillaki, Nimrang, Sultoni kabi navlardan qilinadigan mayiz", isCorrect: false },
      ],
    },
    {
      questionText: "Germiyon-bu...",
      answerOptions: [
        { id: 1, answerText: "qora kishmishdan tayyorlanadi", isCorrect: false },
        { id: 2, answerText: "Kattaqo‘rg‘on, Sultoni, Nimrang kabi yirik g‘ujumli uzum navlaridan tayyorlanadi. ", isCorrect: true },
        { id: 3, answerText: "oq kishmishdan tayyorlanadi", isCorrect: false, },
        { id: 4, answerText: "maxsus quritish qurilmasida, oltingugurt qo‘llab  oq kishmishdan tayyorlanadi", isCorrect: false },
      ],
    },
    {
      questionText: "Avlon-bu...",
      answerOptions: [
        { id: 1, answerText: "uzumning maxsus navlarini soyada quritilgan mayiz", isCorrect: false },
        { id: 2, answerText: "maxsus quritish qurilmasida quritilgan mayiz", isCorrect: false },
        { id: 3, answerText: "sun’iy usulda quritilgan mayiz", isCorrect: false, },
        { id: 4, answerText: "har xil nav uzumlardan dorilanmay, faqat oftobda quritib olingan mayiz.", isCorrect: true },
      ],
    },
    {
      questionText: "0ftobi- bu...",
      answerOptions: [
        { id: 1, answerText: "maxsus quritish qurilmasida quritish usuli", isCorrect: false },
        { id: 2, answerText: "qaynoq ishqor bilan ishlov bermasdan ochiq, oftob yaxshi tushadigan maydonlarda yoyib quritish usuli. ", isCorrect: true },
        { id: 3, answerText: "sun’iy usulda quritish usuli", isCorrect: false, },
        { id: 4, answerText: "maxsus soyada quritish usuli", isCorrect: false },
      ],
    },
    {
      questionText: "Oftobi usulning kamchiligi –bu...",
      answerOptions: [
        { id: 1, answerText: "mayiz to‘liq qurimaydi", isCorrect: false },
        { id: 2, answerText: "faqat Kattaqo‘rg‘on, Sultoni, Nimrang kabi navlari quritiladi", isCorrect: false },
        { id: 3, answerText: "mayiz juda uzoq vaqt quritiladi, iflosligi birmuncha ko‘p bo‘ladi, quruq mahsulot chiqishi kam bo‘ladi (22-25%).", isCorrect: true, },
        { id: 4, answerText: "oftob yaxshi tushadigan maydon topish muammo", isCorrect: false },
      ],
    },
    {
      questionText: "Oftobi usulining quritish davomiyligi...",
      answerOptions: [
        { id: 1, answerText: "20-30 kun davom etadi", isCorrect: true },
        { id: 2, answerText: "Bir xafta davom etadi", isCorrect: false },
        { id: 3, answerText: "10 kun davom etadi", isCorrect: false, },
        { id: 4, answerText: "5 kun davom etadi", isCorrect: false },
      ],
    },
    {
      questionText: "0bjo‘sh- bu...",
      answerOptions: [
        { id: 1, answerText: "soyada quritish usuli", isCorrect: false },
        { id: 2, answerText: "uzumni ishqorli qaynoq suvga botirib olib oftobga yoyib quritish usuli.", isCorrect: true },
        { id: 3, answerText: "maxsus quritish qurilmasida quritish usuli", isCorrect: false, },
        { id: 4, answerText: "faqat oq va qora kishmishni sun’iy quritish usuli", isCorrect: false },
      ],
    },
    {
      questionText: "Objo‘sh quritish usulida asosan qaysi navlar quritiladi?",
      answerOptions: [
        { id: 1, answerText: "Vinobob uzum navlari quritiladi.", isCorrect: false },
        { id: 2, answerText: "Oq kishmish quritiladi.", isCorrect: false },
        { id: 3, answerText: "Qora kishmish quritiladi.", isCorrect: false, },
        { id: 4, answerText: "Kattaqo‘rgon, Sultoni, Rizamat, Nimrang singari yirik donali uzum navlari quritiladi.", isCorrect: true },
      ],
    },
    {
      questionText: "Objo‘sh quritish usulida necha % li ishqorda, qancha vaqt botiriladi?",
      answerOptions: [
        { id: 1, answerText: "1% li qaynoq ishqorga 10 sekund botiriladi", isCorrect: false },
        { id: 2, answerText: "0,3-0,4% li qaynoq ishqorga 6-8 sekund botiriladi", isCorrect: true },
        { id: 3, answerText: " 1-1,5% li qaynoq ishqorga 15 sekund botiriladi", isCorrect: false, },
        { id: 4, answerText: "2% li qaynoq ishqorga 20 sekund botiriladi", isCorrect: false },
      ],
    },
    {
      questionText: "Objo‘sh quritish usulida necha foizl mayiz olish mumkin?",
      answerOptions: [
        { id: 1, answerText: "45-50%", isCorrect: false },
        { id: 2, answerText: "40-45%", isCorrect: false },
        { id: 3, answerText: "35-40%", isCorrect: false, },
        { id: 4, answerText: "26-30%", isCorrect: true },
      ],
    },
    {
      questionText: "Shtabel-bu usul...",
      answerOptions: [
        { id: 1, answerText: "asosan oq rangli uzumlar quritilib oltingugurt bilan dudlanadi.", isCorrect: true },
        { id: 2, answerText: "qora rangli uzumlar quritilib oltingugurt bilan dudlanmaydi.", isCorrect: false },
        { id: 3, answerText: "maxsus uzum navlari quritiladi.", isCorrect: false, },
        { id: 4, answerText: "Vinobob uzum navlari quritiladi.", isCorrect: false },
      ],
    },
    {
      questionText: "Shtabel usulda quritish davomiyligi necha kun davom etadi?",
      answerOptions: [
        { id: 1, answerText: "quritish 30-40 kun davom etadi.", isCorrect: false },
        { id: 2, answerText: "quritish 40-45 kun davom etadi.", isCorrect: false },
        { id: 3, answerText: "quritish 15-25 kun davom etadi. ", isCorrect: true, },
        { id: 4, answerText: "quritish 50-55 kun davom etadi.", isCorrect: false },
      ],
    },
    {
      questionText: "Shtabel usulda uzum quritilganda necha foiz kishmish va necha foiz mayiz olish mumkin?",
      answerOptions: [
        { id: 1, answerText: "30-40% kishmish, 30-35% mayiz olinishi mumkin", isCorrect: false },
        { id: 2, answerText: "27-32% kishmish, 26-27% mayiz olinishi mumkin", isCorrect: true },
        { id: 3, answerText: "35-40% kishmish, 40-45% mayiz olinishi mumkin", isCorrect: false, },
        { id: 4, answerText: "40-45% kishmish, 45-50% mayiz olinishi mumkin", isCorrect: false },
      ],
    },
    {
      questionText: "Shtabel usulda quritilgan mayizning qanddorligi va namligi necha foiz bo‘lishi lozim?",
      answerOptions: [
        { id: 1, answerText: "qanddorligi 80-85%, namligi 35-40% atrofida bo‘lishi lozim", isCorrect: false },
        { id: 2, answerText: "qanddorligi 75-80%, namligi 30-35% atrofida bo‘lishi lozim", isCorrect: false },
        { id: 3, answerText: "qanddorligi 70-75%, namligi 25-30% atrofida bo‘lishi lozim", isCorrect: false, },
        { id: 4, answerText: "qanddorligi 62-68%, namligi 17-18% atrofida bo‘lishi lozim", isCorrect: true },
      ],
    },
    {
      questionText: "Olma mahsulotning sifatiga, qirqish va shibbalashga bog‘liq xolda necha foiz sharbat chiqadi?",
      answerOptions: [
        { id: 1, answerText: "55-80%", isCorrect: true },
        { id: 2, answerText: "80-85%", isCorrect: false },
        { id: 3, answerText: "85-90%", isCorrect: false, },
        { id: 4, answerText: "90-95%", isCorrect: false },
      ],
    },
    {
      questionText: "Gilos mahsulotning sifatiga, qirqish va shibbalashga bog‘liq xolda necha foiz sharbat chiqadi?",
      answerOptions: [
        { id: 1, answerText: "70-75%", isCorrect: false },
        { id: 2, answerText: "60-70%", isCorrect: true },
        { id: 3, answerText: "75-80%", isCorrect: false, },
        { id: 4, answerText: "80-85% ", isCorrect: false },
      ],
    },
    {
      questionText: "Olxo‘ri mahsulotning sifatiga, qirqish va shibbalashga bog‘liq xolda necha foiz sharbat chiqadi?",
      answerOptions: [
        { id: 1, answerText: "70-80%", isCorrect: true },
        { id: 2, answerText: "85-90%", isCorrect: false },
        { id: 3, answerText: "90-95%", isCorrect: false, },
        { id: 4, answerText: "95-100%", isCorrect: false },
      ],
    },
    {
      questionText: "Qizil smorodina mahsulotning sifatiga, qirqish va shibbalashga bog‘liq xolda necha foiz sharbat chiqadi?",
      answerOptions: [
        { id: 1, answerText: "85-90%", isCorrect: false },
        { id: 2, answerText: "90-95%", isCorrect: false },
        { id: 3, answerText: "70-80%", isCorrect: true, },
        { id: 4, answerText: "95-100%", isCorrect: false },
      ],
    },
    {
      questionText: " Qora smorodina mahsulotning sifatiga, qirqish va shibbalashga bog‘liq xolda necha foiz sharbat chiqadi?",
      answerOptions: [
        { id: 1, answerText: "95-100%", isCorrect: false },
        { id: 2, answerText: "90-95%", isCorrect: false },
        { id: 3, answerText: "85-90%", isCorrect: false, },
        { id: 4, answerText: "55-70%", isCorrect: true },
      ],
    },
    {
      questionText: "Uzum mahsulotning sifatiga, qirqish va shibbalashga bog‘liq xolda necha foiz sharbat chiqadi?",
      answerOptions: [
        { id: 1, answerText: "95-100%", isCorrect: false },
        { id: 2, answerText: "90-95%", isCorrect: false },
        { id: 3, answerText: "70-80%", isCorrect: true, },
        { id: 4, answerText: "85-90%", isCorrect: false },
      ],
    },
    {
      questionText: "Pomidor sharbati press-ekstraktor yordamida siqib olingan sharbatda quruq modda miqdori necha foizdan kam bo‘lmasligi lozim?",
      answerOptions: [
        { id: 1, answerText: "4,5% dan", isCorrect: true },
        { id: 2, answerText: "6% dan", isCorrect: false },
        { id: 3, answerText: "7% dan", isCorrect: false, },
        { id: 4, answerText: "8% dan", isCorrect: false },
      ],
    },
    {
      questionText: "Mag‘izli sharbatlarni suyultirish maqsadida shakar qiyomning 16-50% li eritmasidan necha foizgacha qo‘shiladi?",
      answerOptions: [
        { id: 1, answerText: "50%", isCorrect: false },
        { id: 2, answerText: "60%", isCorrect: true },
        { id: 3, answerText: "70%", isCorrect: false, },
        { id: 4, answerText: "80%", isCorrect: false },
      ],
    },
    {
      questionText: "Qanday xolatga pasterilizatsiya deyiladi.",
      answerOptions: [
        { id: 1, answerText: "Qanday xolatga pasterilizatsiya deyiladi.", isCorrect: true },
        { id: 2, answerText: "Sabzavot va mevalarni 100 0S dan yuqori haroratda qizdirib konservalashga", isCorrect: false },
        { id: 3, answerText: "Sabzavot va mevalarni 10-150S gacha haroratda qizdirib konservalashga", isCorrect: false, },
        { id: 4, answerText: "Sabzavot va mevalarni xar xil  haroratda qizdirib konservalashga", isCorrect: false },
      ],
    },
    {
      questionText: "Sabzavot konservalarining turlarini ko‘rsating: ",
      answerOptions: [
        { id: 1, answerText: "Shakar qo‘shilgan meva konservalari; Gazak uchun sabzavot konservalari; Pomidor konservalari; Marinadlangan sabzavotlar.", isCorrect: false },
        { id: 2, answerText: "Kompotlar; Gazak uchun sabzavot konservalari; Pomidor konservalari; Marinadlangan sabzavotlar.", isCorrect: false },
        { id: 3, answerText: "Meva sharbatlari; Gazak uchun sabzavot konservalari; Pomidor konservalari; Marinadlangan sabzavotlar.", isCorrect: false, },
        { id: 4, answerText: "Tabiiy sabzavot konservalari; Gazak uchun sabzavot konservalari; Pomidor konservalari; Marinadlangan sabzavotlar.", isCorrect: true },
      ],
    },
  
    {
      questionText: "Meva va rezavor meva konservalarining turlarini ko‘rsating: ",
      answerOptions: [
        { id: 1, answerText: "Tabiiy sabzavot konservalari; Meva sharbatlari; Shakar qo‘shilgan meva konservalari; Marinadlangan mevalar.", isCorrect: false },
        { id: 2, answerText: "Pomidor konservalari; Meva sharbatlari; Shakar qo‘shilgan meva konservalari; Marinadlangan mevalar.", isCorrect: false },
        { id: 3, answerText: "Kompotlar; Meva sharbatlari; Shakar qo‘shilgan meva konservalari; Marinadlangan mevalar.", isCorrect: true, },
        { id: 4, answerText: "Gazak uchun sabzavot konservalari; Meva sharbatlari; Shakar qo‘shilgan meva konservalari; Marinadlangan mevalar.", isCorrect: false },
      ],
    },
    {
      questionText: "Hujayra shirasi taxir ta’mli va ta’mi taxir bo‘lmaganlari sabzavot va mevalar qancha yuqori haroratda sterilizatsiya qilinadi?",
      answerOptions: [
        { id: 1, answerText: "taxir ta’mli 10 0S gacha, ta’mi taxir bo‘lmaganlari 20 0S dan yuqori haroratda", isCorrect: false },
        { id: 2, answerText: "taxir ta’mli 30 0S gacha, ta’mi taxir bo‘lmaganlari 20 0S dan yuqori haroratda", isCorrect: false },
        { id: 3, answerText: "taxir ta’mli 85-90 0S gacha, ta’mi taxir bo‘lmaganlari 100 0S dan yuqori haroratda", isCorrect: true, },
        { id: 4, answerText: "taxir ta’mli 40 0S gacha, ta’mi taxir bo‘lmaganlari 20 0S dan yuqori haroratda", isCorrect: false },
      ],
    },
    {
      questionText: "Tabiiy sabzavot konservalarida sabzavotning mazasi, xushbo‘y hidi, asosan vitaminlar yaxshi saqlangan konservalar tarkibida (suyuqligi bilan hisoblanganda), ko‘k no‘xatda necha mg. S vitamin bo‘ladi?",
      answerOptions: [
        { id: 1, answerText: "15-25 mg", isCorrect: false },
        { id: 2, answerText: "10-20 mg", isCorrect: true },
        { id: 3, answerText: "25-35 mg", isCorrect: false, },
        { id: 4, answerText: "35-45 mg", isCorrect: false },
      ],
    },
    {
      questionText: "Tabiiy sabzavot konservalarida sabzavotning mazasi, xushbo‘y hidi, asosan vitaminlar yaxshi saqlangan konservalar tarkibida (suyuqligi bilan hisoblanganda), gulkaramda necha mg. S vitamin bo‘ladi?",
      answerOptions: [
        { id: 1, answerText: "70 mg", isCorrect: false },
        { id: 2, answerText: "60 mg", isCorrect: false },
        { id: 3, answerText: "50 mg", isCorrect: false, },
        { id: 4, answerText: "25-30 mg ", isCorrect: true },
      ],
    },
    {
      questionText: "Kompot deb nimaga aytiladi?",
      answerOptions: [
        { id: 1, answerText: "Meva hamda rezavor mevalardan shakar qo‘shmasdan termosterilizatsiya yordamida olingan meva konservalari kompot deb yuritiladi.", isCorrect: false },
        { id: 2, answerText: "Yangi uzilgan, quritilgan, konservalangan va yangi muzlatilgan meva hamda rezavor mevalardan shakar qo‘shib termosterilizatsiya yordamida olingan tabiiy meva konservalari kompot deb yuritiladi.", isCorrect: true },
        { id: 3, answerText: "Sabzavot va mevalardan shakar qo‘shmasdan termosterilizatsiya yordamida olingan sabzavot va meva konservalari kompot deb yuritiladi. ", isCorrect: false, },
        { id: 4, answerText: "Sabzavot va mevalarni siqib olingan sabzavot va mevalarga kompot deb yuritiladi.", isCorrect: false },
      ],
    },
    {
      questionText: "Pomidor massasini tabiiy rangini qanday saqlab qolish mumkin? ",
      answerOptions: [
        { id: 1, answerText: "yopiq idishda qaynatish orqali tabiiy rangini saqlab qolish mumkin.", isCorrect: false },
        { id: 2, answerText: "ochiq idishda qaynatish orqali tabiiy rangini saqlab qolish mumkin.", isCorrect: false },
        { id: 3, answerText: "kislorodsiz muhitda past haroratda qaynatish orqali tabiiy rangini saqlab qolish mumkin.", isCorrect: true, },
        { id: 4, answerText: "pomidor massasini qaynatganda uning rangi o‘zgarmaydi.", isCorrect: false },
      ],
    },
    {
      questionText: "Tomat-pasta olishda pomidor mag‘zini vakuumda qancha bosim va qanday haroratda qaynatiladi? ",
      answerOptions: [
        { id: 1, answerText: "vakuumda 0,12-0,14 bosimda va 45-50 0S haroratda qaynatiladi.", isCorrect: true },
        { id: 2, answerText: "vakuumda 1-2 bosimda va 70-80 0S haroratda qaynatiladi.", isCorrect: false },
        { id: 3, answerText: "vakuumda 2-3 bosimda va 85-90 0S haroratda qaynatiladi.", isCorrect: false, },
        { id: 4, answerText: "vakuumda 3-4 bosimda va 90-95 0S haroratda qaynatiladi.", isCorrect: false },
      ],
    },
    {
      questionText: "Yuqori issiqlik yordamida sabzavot va mevalarni qayta ishlashda qanday omillarning rivojlanishiga salbiy ta’sir ko‘rsatadi?",
      answerOptions: [
        { id: 1, answerText: "shakarlik miqdorini ko‘payishiga", isCorrect: false },
        { id: 2, answerText: "mikroorganizmlarning rivojlanishiga", isCorrect: true },
        { id: 3, answerText: "vitaminlarning ko‘payishiga", isCorrect: false, },
        { id: 4, answerText: "sharbat rangini o‘zgarishiga", isCorrect: false },
      ],
    },
    {
      questionText: "Murabboda necha foiz quruq modda bo‘ladi?",
      answerOptions: [
        { id: 1, answerText: "100%", isCorrect: false },
        { id: 2, answerText: "90-95%", isCorrect: false },
        { id: 3, answerText: "80-85%", isCorrect: false, },
        { id: 4, answerText: "70-75%", isCorrect: true },
      ],
    },
    {
      questionText: "Haroratning necha gradusga ko‘tarilishi mikroblarning aksariyat qismini o‘ldiradi?",
      answerOptions: [
        { id: 1, answerText: "25 0S", isCorrect: false },
        { id: 2, answerText: "100 0S", isCorrect: true },
        { id: 3, answerText: "50 0S", isCorrect: false, },
        { id: 4, answerText: "75 0S", isCorrect: false },
      ],
    },
    {
      questionText: "Issiqlikka chidamli bakteriyalar necha gradus haroratga chidaydi?",
      answerOptions: [
        { id: 1, answerText: "60 0S", isCorrect: false },
        { id: 2, answerText: "80 0S", isCorrect: false },
        { id: 3, answerText: "100 0S", isCorrect: false, },
        { id: 4, answerText: "120 0S", isCorrect: true },
      ],
    },
    {
      questionText: "Olma, nok, shaftoli, gilos va o‘riklardan murabbo tayyorlashda necha foizli shakar qiyomidan foydalaniladi?",
      answerOptions: [
        { id: 1, answerText: "40-60% li", isCorrect: true },
        { id: 2, answerText: "60-70% li", isCorrect: false },
        { id: 3, answerText: "70-80% li", isCorrect: false, },
        { id: 4, answerText: "80-90% li", isCorrect: false },
      ],
    },
    {
      questionText: "Yertutdan murabbo tayyorlashda necha foizli shakar qiyomidan foydalaniladi?",
      answerOptions: [
        { id: 1, answerText: "100%", isCorrect: false },
        { id: 2, answerText: "90%", isCorrect: false },
        { id: 3, answerText: "70%", isCorrect: true, },
        { id: 4, answerText: "80%", isCorrect: false },
      ],
    },
    {
      questionText: "Olxo‘ridan murabbo tayyorlashda necha foizli shakar qiyomidan foydalaniladi?",
      answerOptions: [
        { id: 1, answerText: "40-50%", isCorrect: false },
        { id: 2, answerText: "25-40%", isCorrect: true },
        { id: 3, answerText: "50-60%", isCorrect: false, },
        { id: 4, answerText: "60-70%", isCorrect: false },
      ],
    },
    {
      questionText: "Meva sharbatlari tayyorlash texnologiyasiga va ularning sifat ko‘rsatkichlariga qarab necha turga bo‘linadi?",
      answerOptions: [
        { id: 1, answerText: "5 turga: tiniq, quyuq (tindirilgan), suyuq (tindirilmagan) va mag‘izli sharbatlar (quyqali), mag‘izsiz sharbatlar.", isCorrect: false },
        { id: 2, answerText: "4 turga: tiniq, quyuq (tindirilmagan), suyuq va mag‘izli sharbatlar (quyqali).", isCorrect: false },
        { id: 3, answerText: "2 turga: tiniq, quyuq (tindirilmagan)", isCorrect: false, },
        { id: 4, answerText: "3 turga: tiniq, quyuq (tindirilmagan) va mag‘izli sharbatlar (quyqali).", isCorrect: true },
      ],
    },
    {
      questionText: "Oksidlanish jarayonini kamaytirish va sharbatning rangini tabiiyligicha saqlab qolish maqsadida necha foiz askorbin kislotasi qo‘shiladi?",
      answerOptions: [
        { id: 1, answerText: " 0,1%", isCorrect: true },
        { id: 2, answerText: "0,5%", isCorrect: false },
        { id: 3, answerText: "0,7%", isCorrect: false, },
        { id: 4, answerText: "0,9%", isCorrect: false },
      ],
    },
    {
      questionText: "100 tonna meva va uzumni quritish uchun o‘rta hisobda qancha kaustik soda va oltingugurt kerak?",
      answerOptions: [
        { id: 1, answerText: "300–350 kg kaustik soda, 550—600 kg oltingugurt", isCorrect: false },
        { id: 2, answerText: "200–250 kg kaustik soda, 150—180 kg oltingugurt.", isCorrect: true },
        { id: 3, answerText: "400–450 kg kaustik soda, 600—650 kg oltingugurt", isCorrect: false, },
        { id: 4, answerText: "500–550 kg kaustik soda, 650—700 kg oltingugurt", isCorrect: false },
      ],
    },
    {
      questionText: "Quritish jarayoni deb...",
      answerOptions: [
        { id: 1, answerText: "Qattiq va pastasimon materiallar tarkibida namlikni bug‘latish va hosil bo‘layotgan bug‘larni chetga olib chiqishga quritish jarayoni deyiladi.", isCorrect: true },
        { id: 2, answerText: "Maxsulotlarni quritish qurilmasiga joylashga quritish jarayoni deyiladi.", isCorrect: false },
        { id: 3, answerText: "Maxsulotlarni oltingugurt bilan ishlov berishga quritish jarayoni deyiladi.", isCorrect: false, },
        { id: 4, answerText: "Maxsulotlarni quritishga tayyorlash quritish jarayoni deyiladi.", isCorrect: false },
      ],
    },
    {
      questionText: "Qaysi maxsulotlarga quritishdan avval issiklik ishlovi (blanshirlash) berilmaydi?",
      answerOptions: [
        { id: 1, answerText: "Uzum, piyoz, xurma, olma, nok, behi va o‘riklarga", isCorrect: false },
        { id: 2, answerText: "Pomidor, piyoz, xurma, olma, nok, behi va o‘riklarga", isCorrect: false },
        { id: 3, answerText: "Piyoz, xurma, olma, nok, behi va o‘riklarga", isCorrect: true, },
        { id: 4, answerText: "Shaftoli, piyoz, xurma, olma, nok, behi va o‘riklarga", isCorrect: false },
      ],
    },
    {
      questionText: "Tunnelli quritgichning kamchiligini ko‘rsating.",
      answerOptions: [
        { id: 1, answerText: "Quritgichlarda qurituvchi agenti umuman resirkulyatsiya qilinmaydi.", isCorrect: false },
        { id: 2, answerText: "Bir vaqtda ko‘p miqdorda maxsulot quritilmaydi. ", isCorrect: false },
        { id: 3, answerText: "Quyosh energiyasidan kam foydalaniladi.", isCorrect: false, },
        { id: 4, answerText: "Quritish tezligi kichik, protsess uzoq vaqt davom etadi, quritish bir me’yorda bormaydi, qo‘l kuchidan foydalaniladi.", isCorrect: true },
      ],
    },
    {
      questionText: "Qanday mevalarni quritish uchun tunnelli quritgichlar yaxshi samara beradi?",
      answerOptions: [
        { id: 1, answerText: "Hamma mevalarni quritishda yaxshi samara beradi.", isCorrect: false },
        { id: 2, answerText: "Sharbat ajralmaydigan mevalarni quritishda yaxshi samara beradi.", isCorrect: false },
        { id: 3, answerText: "Oson sharbat ajraluvchi (qorali, o‘rik, uzum) mevalarni quritishda yaxshi samara beradi.", isCorrect: true, },
        { id: 4, answerText: "Sabzavot maxsulotlarni quritishda yaxshi samara beradi.", isCorrect: false },
      ],
    },
    {
      questionText: "Lentali quritgichlarda  solishtirma ish unumi va solishtirma issiqlik sarfi miqdorini ko‘rsating.",
      answerOptions: [
        { id: 1, answerText: "Solishtirma ish unumi kichik, solishtirma issiqlik sarfi esa katta", isCorrect: true },
        { id: 2, answerText: "Solishtirma ish unumi va solishtirma issiqlik sarfi katta", isCorrect: false },
        { id: 3, answerText: "Solishtirma ish unumi va solishtirma issiqlik sarfi kichik", isCorrect: false, },
        { id: 4, answerText: "Solishtirma ish unumi katta, solishtirma issiqlik sarfi kichik ", isCorrect: false },
      ],
    },
    {
      questionText: "Lentali quritgichlarda qanday maxsulotlarni quritish mumkin emas? ",
      answerOptions: [
        { id: 1, answerText: "Oson sharbat ajraluvchi mevalarni quritish mumkin emas", isCorrect: false },
        { id: 2, answerText: "Pastasimon mahsulotlarni quritish mumkin emas.", isCorrect: true },
        { id: 3, answerText: "Urug‘li mevalarni quritish mumkin emas", isCorrect: false, },
        { id: 4, answerText: "Urug‘siz mevalarni quritish mumkin emas", isCorrect: false },
      ],
    },
    {
      questionText: "Sochib beruvchi quritkichlarning ishlash prinsipini ko‘rsating.",
      answerOptions: [
        { id: 1, answerText: "Mahsulot juda mayda qilib sochib beriladi va parallel oqimda harakat qilayotgan qurituvchi agent bilan to‘qnashadi.", isCorrect: true },
        { id: 2, answerText: "Maxsulot bilan quritish agenti perpendikulyar harakat qiladi.", isCorrect: false },
        { id: 3, answerText: "Maxsulot taxlanib keyin quritish agenti beriladi", isCorrect: false, },
        { id: 4, answerText: "Maxsulot va quritish agenti bitta yo‘nalishda harakat qiladi.", isCorrect: false },
      ],
    },
    {
      questionText: "Sochib beruvchi quritkichlarda qanday tayyor maxsulot olinadi?",
      answerOptions: [
        { id: 1, answerText: "Suyuq mahsulot olinadi.", isCorrect: false },
        { id: 2, answerText: "Quyuq mahsulot olinadi.", isCorrect: false },
        { id: 3, answerText: "Pastasimon mahsulot olinadi.", isCorrect: false, },
        { id: 4, answerText: "Kukunsimon mahsulot olinadi.", isCorrect: true },
      ],
    },
    {
      questionText: "Olmadan necha foiz qoqi olinadi?",
      answerOptions: [
        { id: 1, answerText: "20-25 % qoqi olinadi.", isCorrect: false },
        { id: 2, answerText: "25-30 % qoqi olinadi.", isCorrect: false },
        { id: 3, answerText: "10-13 % qoqi olinadi.", isCorrect: true, },
        { id: 4, answerText: "30-35 % qoqi olinadi.", isCorrect: false },
      ],
    },
    {
      questionText: "Tayyor mahsulotni namligi olmada va nokda necha foizdan oshmasligi kerak?",
      answerOptions: [
        { id: 1, answerText: "Olmada 30% dan,  nokda 40%dan oshmasligi kerak.", isCorrect: false },
        { id: 2, answerText: "Olmada 40% dan,  nokda 50%dan oshmasligi kerak.", isCorrect: false },
        { id: 3, answerText: "Olmada 20% dan,  nokda 24%dan oshmasligi kerak.", isCorrect: true, },
        { id: 4, answerText: "Olmada 50% dan,  nokda 60%dan oshmasligi kerak.", isCorrect: false },
      ],
    },
    {
      questionText: "Quritish usuliga qarab olmadan va nokdan necha foiz quruq maxsulot olish mumkin?",
      answerOptions: [
        { id: 1, answerText: "Olmadan 25-35% gacha, nokdan 20-30% gacha", isCorrect: false },
        { id: 2, answerText: "Olmadan 17-22% gacha, nokdan 16-18% gacha", isCorrect: true },
        { id: 3, answerText: "Olmadan 35-40% gacha, nokdan 40-50% gacha", isCorrect: false, },
        { id: 4, answerText: "Olmadan 45-50% gacha, nokdan 35-50% gacha", isCorrect: false },
      ],
    },
    {
      questionText: "Qanday qurilmalarga sublimatsiyali quritgichlar deyiladi?",
      answerOptions: [
        { id: 1, answerText: "Issiqlik tashuvchi agent va ho‘l mahsulot o‘rtasida ularni ajratib turuvchi devor bo‘lgan quritishga sublimatsiyali quritish deb ataladi.", isCorrect: false },
        { id: 2, answerText: "Nam materiallarni infraqizil nurlari bilan quritishda materialni qizitish va bug‘latish uchun zarur bo‘ladigan issiqlik nur energiyasi orqali berilishiga  sublimatsiyali quritish deb ataladi. ", isCorrect: false },
        { id: 3, answerText: "Materiallarni quritishda beriladigan issiqlik quritilayotgan material va isiyotgan  yuza bilan bevosita kontaktda bo‘lishi sublimatsiyali quritish deb ataladi.", isCorrect: false, },
        { id: 4, answerText: "Mahsulotlarni muzlagan holda yuqori vakuum ostida suvsizlantirish sublimatsiyali quritish deb ataladi.", isCorrect: true },
      ],
    },
    {
      questionText: "Sublimatsiyali quritgichlarda mahsulot tarkibidan namlikni chiqarib yuborish necha bosqichdan iborat?",
      answerOptions: [
        { id: 1, answerText: "4 bosqichdan", isCorrect: false },
        { id: 2, answerText: "3 bosqichdan", isCorrect: true },
        { id: 3, answerText: "5 bosqichdan", isCorrect: false, },
        { id: 4, answerText: "6 bosqichdan", isCorrect: false },
      ],
    },
    {
      questionText: "O‘rikni turshak usulida quritish – bu...",
      answerOptions: [
        { id: 1, answerText: "ikkiga yorib quritilgan o‘rikdir.", isCorrect: false },
        { id: 2, answerText: "mevalar ikkiga bo‘linib danaksiz quritiladi.", isCorrect: false },
        { id: 3, answerText: " mevalar butunligicha quritiladi.", isCorrect: true, },
        { id: 4, answerText: "mevalar	butunligicha quritilib	danagining	mag‘zi	uning	 ichiga solinadi.", isCorrect: false },
      ],
    },
    {
      questionText: "O‘rikni kuraga usulida quritish – bu...",
      answerOptions: [
        { id: 1, answerText: "ikkiga yorib quritilgan o‘rikdir.", isCorrect: true },
        { id: 2, answerText: "mevalar butunligicha quritiladi.", isCorrect: false },
        { id: 3, answerText: "mevalar ikkiga bo‘linib danaksiz quritiladi.", isCorrect: false, },
        { id: 4, answerText: "mevalar	butunligicha	quritilib	danagining	mag‘zi	uning	ichiga solinadi.", isCorrect: false },
      ],
    },
    {
      questionText: "O‘rikni bargak usulida quritish – bu...",
      answerOptions: [
        { id: 1, answerText: "ikkiga yorib quritilgan o‘rikdir.", isCorrect: false },
        { id: 2, answerText: "mevalar ikkiga bo‘linib danaksiz quritiladi.", isCorrect: true },
        { id: 3, answerText: "mevalar butunligicha quritiladi.", isCorrect: false, },
        { id: 4, answerText: "mevalar	butunligicha	quritilib	danagining	mag‘zi	uning	ichiga solinadi.", isCorrect: false },
      ],
    },
    {
      questionText: "O‘rikni ashtak usulida quritish – bu...",
      answerOptions: [
        { id: 1, answerText: "mevalar butunligicha quritiladi.", isCorrect: false },
        { id: 2, answerText: "mevalar ikkiga bo‘linib danaksiz quritiladi.", isCorrect: false },
        { id: 3, answerText: "ikkiga yorib quritilgan o‘rikdir.", isCorrect: false, },
        { id: 4, answerText: "mevalar	butunligicha	quritilib	danagining	mag‘zi	uning	ichiga solinadi.", isCorrect: true },
      ],
    },
    {
      questionText: "O‘rta xisobda 1 m3 joyga necha kg olma qoqisini joylash mumkin?",
      answerOptions: [
        { id: 1, answerText: "550 kg", isCorrect: false },
        { id: 2, answerText: "400 kg", isCorrect: true },
        { id: 3, answerText: "450 kg", isCorrect: false, },
        { id: 4, answerText: "650 kg", isCorrect: false },
      ],
    },
    {
      questionText: "O‘rta xisobda 1 m3 joyga necha kg nok qoqisini joylash mumkin?",
      answerOptions: [
        { id: 1, answerText: "650 kg", isCorrect: false },
        { id: 2, answerText: "450 kg", isCorrect: false },
        { id: 3, answerText: "550 kg", isCorrect: false, },
        { id: 4, answerText: "500 kg", isCorrect: true },
      ],
    },
    {
      questionText: "O‘rta xisobda 1 m3 joyga necha kg olxo‘ri qoqisini joylash mumkin?",
      answerOptions: [
        { id: 1, answerText: "600 kg", isCorrect: true },
        { id: 2, answerText: "550 kg", isCorrect: false },
        { id: 3, answerText: "450 kg", isCorrect: false, },
        { id: 4, answerText: "650 kg", isCorrect: false },
      ],
    },
    {
      questionText: "O‘rta xisobda 1 m3 joyga necha kg o‘rik (turshak) qoqisini joylash mumkin?",
      answerOptions: [
        { id: 1, answerText: "650 kg", isCorrect: false },
        { id: 2, answerText: "450 kg", isCorrect: false },
        { id: 3, answerText: "770 kg", isCorrect: true, },
        { id: 4, answerText: "550 kg", isCorrect: false },
      ],
    },
    {
      questionText: "O‘rta xisobda 1 m3 joyga necha kg olcha qoqisini joylash mumkin?",
      answerOptions: [
        { id: 1, answerText: "550 kg", isCorrect: false },
        { id: 2, answerText: "600 kg", isCorrect: true },
        { id: 3, answerText: "450 kg", isCorrect: false, },
        { id: 4, answerText: "650 kg", isCorrect: false },
      ],
    },
    {
      questionText: "O‘rta xisobda 1 m3 joyga necha kg mayiz joylash mumkin?",
      answerOptions: [
        { id: 1, answerText: "650 kg", isCorrect: false },
        { id: 2, answerText: "450 kg", isCorrect: false },
        { id: 3, answerText: "550 kg", isCorrect: false, },
        { id: 4, answerText: "600 kg", isCorrect: true },
      ],
    },
    {
      questionText: "Quritilgan chilonjiydada qanddorligi va kislotaligi necha foizni tashkil qiladi?",
      answerOptions: [
        { id: 1, answerText: "Qanddorligi 55-65 % , kislotaligi 1-1,5 %.", isCorrect: true },
        { id: 2, answerText: "Qanddorligi 70-75 % , kislotaligi 2-2,5 %.", isCorrect: false },
        { id: 3, answerText: "Qanddorligi 80-85 % , kislotaligi 3-3,5 %.", isCorrect: false, },
        { id: 4, answerText: "Qanddorligi 90-95 % , kislotaligi 4-4,5 %.", isCorrect: false },
      ],
    },
    {
      questionText: "Olxo‘ridan qancha quruq mahsulot olinadi?",
      answerOptions: [
        { id: 1, answerText: "40-45 % gacha", isCorrect: false },
        { id: 2, answerText: "24-36 % gacha", isCorrect: true },
        { id: 3, answerText: "50-55 % gacha", isCorrect: false, },
        { id: 4, answerText: "60-65 % gacha", isCorrect: false },
      ],
    },
    {
      questionText: "Shaftolini quritish usuli va naviga qarab necha foizgacha mahsulot olinadi?",
      answerOptions: [
        { id: 1, answerText: "14-20% gacha mahsulot olinadi.", isCorrect: true },
        { id: 2, answerText: "30-35% gacha mahsulot olinadi.", isCorrect: false },
        { id: 3, answerText: "40-45% gacha mahsulot olinadi.", isCorrect: false, },
        { id: 4, answerText: "50-55% gacha mahsulot olinadi.", isCorrect: false },
      ],
    },
    {
      questionText: "Quritilgan meva-sabzavot va kartoshka nima uchun qadoqlanadi?",
      answerOptions: [
        { id: 1, answerText: "Chiroyli ko‘rinish uchun qadoqlanadi.", isCorrect: false },
        { id: 2, answerText: "Quyoshdan ximoyalash uchun qadoqlanadi.", isCorrect: false },
        { id: 3, answerText: "Tashqi muhit ta’siridan (namligini yo‘qotishdan, zararkunandalar bilan zararlanishdan saqlash maqsadida) himoyalash uchun qadoqlanadi.", isCorrect: true, },
        { id: 4, answerText: "Tashish qulay bo‘lishi uchun qadoqlanadi.", isCorrect: false },
      ],
    },
    {
      questionText: "Qurigan mevalarni saqlashda xonadagi qaysi parametrlarni muntazam ravishda kuzatib turish lozim?",
      answerOptions: [
        { id: 1, answerText: "Nisbiy namligini va saqlash xonasining yorug‘ligini", isCorrect: false },
        { id: 2, answerText: "Havo harorati va maxsulot taxlanishini ", isCorrect: false },
        { id: 3, answerText: "Saqlash xonasini zich yopilganligini va havo xaroratini ", isCorrect: false, },
        { id: 4, answerText: "Havo harorati va nisbiy namligini ", isCorrect: true },
      ],
    },
    {
      questionText: "Kuritish uskunalarini foydali ish koeffitsenti deb nimaga aytiladi.",
      answerOptions: [
        { id: 1, answerText: "Kuritish uskunalarini foydali ish koeffitsenti deb-issiklik yig‘indisiga aytiladi.", isCorrect: false },
        { id: 2, answerText: "Kuritish uskunalarini foydali ish koeffitsenti deb-haqiqiy  sarflangan  issiklikka   aytiladi.", isCorrect: false },
        { id: 3, answerText: " Quritish uskunalarini foydali ish koeffitsenti deb-foydalanilgan haqiqiy issiklikning haqiqiy  sarflangan  issiklik  nisbatiga   aytiladi.", isCorrect: true, },
        { id: 4, answerText: "Quritish uskunalarini foydali ish koeffitsenti deb-foydalanilgan haqiqiy issikligiga   aytiladi.", isCorrect: false },
      ],
    },
    {
      questionText: "Dielektrik quritishda maxsulot...",
      answerOptions: [
        { id: 1, answerText: "Mahsulot yuqori chastotali tok maydonida qizdiriladi", isCorrect: true },
        { id: 2, answerText: "Mahsulot muzlagan holda, yuqori vakuum ostida suvsizlantiriladi", isCorrect: false },
        { id: 3, answerText: "Xo‘l mahsulot bilan qurituvchi agent to‘g‘ridan-to‘g‘ri o‘zaro aralashadi", isCorrect: false, },
        { id: 4, answerText: "Issiqlik tashuvchi agent va ho‘l mahsulot o‘rtasida ularni ajratib turuvchi devor bo‘ladi", isCorrect: false },
      ],
    },
    {
      questionText: "O‘simliklar tarkibidagi quruq modda miqdorining necha foizini uglevodlar tashkil qiladi?",
      answerOptions: [
        { id: 1, answerText: "85 % ini uglevodlar tashkil qiladi.", isCorrect: false },
        { id: 2, answerText: "80 % ini uglevodlar tashkil qiladi.", isCorrect: true },
        { id: 3, answerText: "75 % ini uglevodlar tashkil qiladi.", isCorrect: false, },
        { id: 4, answerText: "65 % ini uglevodlar tashkil qiladi.", isCorrect: false },
      ],
    },
    {
      questionText: "Uglevodlar guruxini ko‘rsating",
      answerOptions: [
        { id: 1, answerText: "Shakar, kraxmal, selluloza, pektin moddalari, gemitsellulozalar ", isCorrect: true },
        { id: 2, answerText: "Glukoza, fruktoza, selluloza, pektin moddalari, gemitsellulozalar ", isCorrect: false },
        { id: 3, answerText: "Azot tuzlari, azot kislotalari,  pektin moddalari, gemitsellulozalar ", isCorrect: false, },
        { id: 4, answerText: "Fruktoza, azot kislotalari, selluloza, gemitsellulozalar ", isCorrect: false },
      ],
    },
  ]